import { render, staticRenderFns } from "./ResearchBoard.vue?vue&type=template&id=7947f841&scoped=true&"
import script from "./ResearchBoard.vue?vue&type=script&lang=ts&"
export * from "./ResearchBoard.vue?vue&type=script&lang=ts&"
import style0 from "./ResearchBoard.vue?vue&type=style&index=0&id=7947f841&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7947f841",
  null
  
)

export default component.exports